import React from 'react';
import Typography from "@mui/joy/Typography";
import {Stack} from "@mui/joy";
import Link from "@mui/joy/Link";

// components
import withNavigate from "../../utils/withNavigate";
import CommonEditModal from "../Common/CommonEditModal";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import ComponentCard from "../Common/ComponentCard";


class ContactDetailHeader extends React.Component{
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            updatePermission: 0,
        };
    }

    async componentDidMount(){
        await this.retrieveUpdatePermission();
    }

    async retrieveUpdatePermission() {
        let p = await retrievePermission(
            'ContactViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState(
            {
                updatePermission: p
            }
        );
    }

    render() {
        return(
            <Stack
                spacing={1}
            >
                <Stack
                    direction={'row'}
                    sx={{
                        position: 'relative',
                    }}
                >
                    <Typography
                        level={'title-md'}
                    >
                        {this.props.contact.last_name} {this.props.contact.first_name} {this.props.contact.patronymic}

                    </Typography>
                    {this.state.updatePermission?
                        <CommonEditModal
                            overlay={true}
                            fields={
                                [
                                    'last_name',
                                    'first_name',
                                    'patronymic'
                                ]
                            }
                            baseUrl={'contact'}
                            obj={this.props.contact}
                            callBack={this.props.callBack}
                        />:
                        null
                    }
                </Stack>
                <Stack
                    direction={'row'}
                    spacing={0.5}
                >
                    <Stack
                        direction={'row'}
                        sx={{
                            position: 'relative',
                        }}
                    >
                        <Typography
                            level={'body-md'}
                        >
                            {!this.props.contact.role || this.props.contact.role === ''?'Не указано':this.props.contact.role}
                        </Typography>
                        {this.state.updatePermission?
                            <CommonEditModal
                                overlay={true}
                                fields={
                                    [
                                        'role',
                                    ]
                                }
                                baseUrl={'contact'}
                                obj={this.props.contact}
                                callBack={this.props.callBack}
                            />:
                            null
                        }
                    </Stack>
                    <ComponentCard
                        entity={this.props.contact.entity}
                        entity_id={this.props.contact.entity_id}
                        nano={true}
                    />
                </Stack>
            </Stack>
        )
    }
}

export default withNavigate(ContactDetailHeader)